import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Users, Briefcase, Globe, ArrowRight } from 'lucide-react';
import '../styles/EngagementModels.css';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay },
});

const models = [
  {
    icon: Users,
    title: 'Dedicated Teams',
    description: 'Build a high-performing engineering team as a seamless extension of your organization.',
    details: [
      'Agile Scrum-based delivery model',
      'Dedicated technical leadership',
      '4-hour minimum time zone overlap',
      'Scalable team ramp-up based on needs'
    ],
    sectionId: 'dedicated-teams-section',
  },
  {
    icon: Briefcase,
    title: 'Project-Based Delivery',
    description: 'End-to-end execution with complete ownership across architecture, development, QA, and deployment.',
    details: [
      'Fixed Bid or Time & Material models',
      'Milestone-based delivery approach',
      'Dedicated QA and testing cycles',
      'Complete project ownership'
    ],
    sectionId: 'project-delivery-section',
  },
  {
    icon: Globe,
    title: 'Hybrid Delivery Model',
    description: 'Combine onsite leadership with offshore engineering scalability for optimal results.',
    details: [
      'Onsite technical leadership',
      'Cost-optimized global delivery',
      'Flexible resource scaling',
      'Distributed agile execution'
    ],
    sectionId: 'hybrid-delivery-section',
  },
];

export default function EngagementModels() {
  const navigate = useNavigate();
  return (
    <section className="section engagement-models">
      <div className="container">
        <motion.div className="engagement__header" {...fadeUp(0)}>
          <div className="section__tag">How We Work</div>
          <h2 className="section__title">Flexible Engagement Models</h2>
        </motion.div>

        <div className="engagement__grid">
          {models.map((model, idx) => {
            const ModelIcon = model.icon;
            return (
              <motion.div
                key={model.title}
                className="engagement-card engagement-card--clickable"
                onClick={() => navigate(`/process#${model.sectionId}`)}
                {...fadeUp(idx * 0.06)}
                whileHover={{ y: -8 }}
                transition={{ duration: 0.3 }}
              >
                <div className="engagement-card__icon">
                  <ModelIcon size={36} strokeWidth={1.5} />
                </div>
                <h3 className="engagement-card__title">{model.title}</h3>
                <p className="engagement-card__description">{model.description}</p>
                <ul className="engagement-card__details">
                  {model.details.map((detail, didx) => (
                    <li key={didx}>{detail}</li>
                  ))}
                </ul>
                <div className="engagement-card__cta">
                  Learn More <ArrowRight size={14} style={{ marginLeft: '6px' }} />
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
